{
  "app": {
    "name": "HUMIS",
    "tagline": "Human Management Intelligence System"
  },
  "common": {
    "search": "Search employees, modules...",
    "globalSearch": "Search employees, modules…",
    "save": "Save",
    "cancel": "Cancel",
    "delete": "Delete",
    "edit": "Edit",
    "create": "Create",
    "close": "Close",
    "confirm": "Confirm",
    "actions": "Actions",
    "loading": "Loading...",
    "noData": "No data to show",
    "error": "Something went wrong",
    "retry": "Retry",
    "export": "Export",
    "viewAll": "View All",
    "today": "Today",
    "thisMonth": "This Month",
    "lastSixMonths": "Last 6 Months",
    "lastTwelveMonths": "Last 12 Months",
    "of": "of",
    "total": "Total",
    "rowsSelected": "{{count}} selected"
  },
  "auth": {
    "signIn": "Sign in",
    "signOut": "Sign out",
    "email": "Email",
    "password": "Password",
    "rememberMe": "Remember me",
    "forgotPassword": "Forgot password?",
    "forgotTitle": "Reset your password",
    "forgotSubtitle": "Enter the email you sign in with. If it has an account, we will send a link to choose a new password.",
    "sendLink": "Send link",
    "sending": "Sending...",
    "forgotSent": "If that email has an account, we have sent a link to it. The link works once and expires in an hour — check your spam folder if it does not arrive.",
    "backToSignIn": "Back to sign in",
    "resetTitle": "Choose a new password",
    "newPassword": "New password",
    "confirmPassword": "Type it again",
    "passwordsDiffer": "The two passwords are different.",
    "setPassword": "Set password",
    "resetDone": "Your password has been changed and you have been signed out everywhere. Sign in with the new password.",
    "resetLinkIncomplete": "This link is incomplete. Open the whole link from the email, or ask for a new one.",
    "requestNewLink": "Ask for a new link",
    "welcomeBack": "Welcome back, {{name}} 👋",
    "signingIn": "Signing in...",
    "invalidCredentials": "Invalid email or password",
    "signInSubtitle": "Sign in to your HUMIS account"
  },
  "nav": {
    "portal": "My workspace",
    "dashboard": "Dashboard",
    "employees": "Employees",
    "recruitment": "Recruitment",
    "attendance": "Attendance",
    "leave": "Leave",
    "timesheets": "Timesheets",
    "payroll": "Payroll",
    "performance": "Performance",
    "loans": "Loans & Advances",
    "assets": "Assets",
    "documents": "Documents",
    "exits": "Exits",
    "compliance": "Compliance",
    "reports": "Reports & Analytics",
    "settings": "Settings",
    "administration": "System Administration",
    "requests": "Requests",
    "pro": "PRO & Government",
    "compensation": "Compensation",
    "expenses": "Expenses & Travel",
    "settlements": "Final Settlement",
    "helpdesk": "Helpdesk",
    "engagement": "Engagement"
  },
  "dashboard": {
    "title": "Dashboard",
    "downloadReport": "Download Report",
    "totalEmployees": "Total Employees",
    "presentToday": "Present Today",
    "onLeaveToday": "On Leave Today",
    "absentToday": "Absent Today",
    "newJoiners": "New Joiners ({{month}})",
    "thisMonth": "{{count}} this month",
    "percentOfTotal": "{{value}}% of total",
    "fromLastMonth": "{{value}}% from last month",
    "attendanceOverview": "Attendance Overview",
    "employeeTrend": "Employee Trend",
    "upcomingEvents": "Upcoming Events",
    "leaveSummary": "Leave Summary",
    "payrollSummary": "Payroll Summary",
    "recruitmentSummary": "Recruitment Summary",
    "quickAccess": "Quick Access",
    "departmentHeadcount": "Department-wise Headcount",
    "recentActivities": "Recent Activities"
  },
  "a11y": {
    "skipToContent": "Skip to main content",
    "toggleSidebar": "Toggle sidebar",
    "notifications": "Notifications, {{count}} unread",
    "userMenu": "User menu",
    "settings": "Settings",
    "expandSection": "Expand {{section}}",
    "collapseSection": "Collapse {{section}}",
    "openCalendar": "Open calendar",
    "previousMonth": "Previous month",
    "nextMonth": "Next month"
  },
  "validation": {
    "required": "This field is required",
    "email": "Enter a valid email address",
    "minLength": "Must be at least {{count}} characters"
  },
  "navChild": {
    "employees": {
      "directory": "Directory",
      "orgChart": "Org structure",
      "transfers": "Transfers",
      "departments": "Departments",
      "divisions": "Divisions",
      "legalEntities": "Legal entities",
      "establishments": "Establishments",
      "masters": "Org masters",
      "positions": "Positions"
    },
    "exits": {
      "cases": "Cases",
      "settings": "Notice & clearance"
    },
    "compliance": {
      "calendar": "Calendar",
      "items": "Obligations",
      "nationalisation": "Nationalisation",
      "filings": "Filings",
      "retention": "Retention review",
      "requests": "Data requests"
    },
    "attendance": {
      "daily": "Daily attendance",
      "roster": "Roster & shifts",
      "holidays": "Holidays",
      "regularisation": "Regularisation",
      "devices": "Devices",
      "sources": "Punch sources",
      "feed": "Live feed",
      "reports": "Reports",
      "kiosks": "Kiosks",
      "geofencing": "Geofencing & face"
    },
    "leave": {
      "requests": "Requests",
      "balances": "Balances",
      "types": "Leave types"
    },
    "timesheets": {
      "myWeek": "My week",
      "projects": "Projects",
      "approvals": "Approvals"
    },
    "settings": {
      "dataMigration": "Data migration",
      "general": "General",
      "branding": "Branding",
      "grants": "User roles & access",
      "segregation": "Segregation of duties",
      "customFields": "Custom fields",
      "notifications": "Notifications",
      "banks": "Banks",
      "ai": "AI & assistant",
      "apiClients": "API clients",
      "webhooks": "Webhooks",
      "sso": "Single sign-on",
      "erpExport": "ERP export"
    },
    "administration": {
      "users": "Users",
      "roles": "Roles & permissions",
      "sessions": "Sessions",
      "accessLog": "Access log",
      "auditLog": "Audit log",
      "workflows": "Workflows",
      "health": "System health"
    },
    "documents": {
      "expiring": "Expiring soon",
      "company": "Company documents",
      "types": "Document types",
      "credentialRules": "Credential rules",
      "letters": "Letter templates",
      "library": "Library",
      "policies": "Policy acknowledgements",
      "librarySetup": "Library setup",
      "signatures": "Signatures"
    },
    "requests": {
      "all": "All requests",
      "mine": "My requests",
      "types": "Request types"
    },
    "pro": {
      "cases": "Case board",
      "processes": "Processes",
      "reports": "Reports"
    },
    "performance": {
      "trainingNeeds": "Training needs",
      "appraisals": "Appraisals",
      "goals": "Goals",
      "calibration": "Calibration",
      "plans": "Improvement plans",
      "setup": "Setup",
      "trainingCatalogue": "Course catalogue",
      "trainingSessions": "Training sessions",
      "trainingBudgets": "Training budgets"
    },
    "reports": {
      "exports": "Scheduled exports",
      "biAccess": "Reporting access",
      "catalogue": "Report catalogue",
      "builder": "Builder"
    },
    "payroll": {
      "myPayslips": "My payslips",
      "runs": "Payroll runs",
      "elements": "Pay elements",
      "provisions": "Provisions & statutory",
      "chartOfAccounts": "Chart of accounts",
      "wps": "WPS layouts",
      "payments": "Payments",
      "reports": "Reports",
      "bankChannels": "Bank channels"
    },
    "compensation": {
      "bands": "Pay bands",
      "revisions": "Salary revisions",
      "benefits": "Benefits"
    },
    "loans": {
      "all": "Loans",
      "types": "Loan types"
    },
    "expenses": {
      "claims": "Claims",
      "types": "Types & limits",
      "travel": "Travel requests",
      "perDiem": "Per-diem rates"
    },
    "settlements": {
      "all": "Settlements",
      "terms": "End-of-service terms"
    },
    "recruitment": {
      "overview": "Overview",
      "requisitions": "Requisitions",
      "candidates": "Candidates",
      "offers": "Offers",
      "settings": "Settings"
    },
    "assets": {
      "register": "Register",
      "categories": "Categories",
      "stocktakes": "Stocktakes",
      "reports": "Reports"
    },
    "helpdesk": {
      "queue": "Tickets",
      "knowledgeBase": "Knowledge base",
      "setup": "Helpdesk setup"
    },
    "engagement": {
      "announcements": "Announcements",
      "surveys": "Surveys",
      "recognition": "Recognition"
    },
    "portal": {
      "home": "My workspace",
      "punch": "Punch in / out",
      "myTeam": "My team",
      "delegation": "Delegation & time away",
      "devices": "My devices"
    }
  },
  "assistant": {
    "title": "Assistant",
    "open": "Open the assistant",
    "newChat": "Start a new conversation",
    "history": "Past conversations",
    "noHistory": "You have not asked anything yet.",
    "untitled": "Untitled conversation",
    "deleteConversation": "Delete this conversation",
    "askLabel": "Ask the assistant",
    "placeholder": "Ask about your leave, payslip, attendance or documents…",
    "send": "Send",
    "thinking": "Working on it…",
    "failed": "Something went wrong answering that. Nothing was changed.",
    "lookedAt": "Looked at {{what}}",
    "wasThisUseful": "Was this useful?",
    "thumbsUp": "This was useful",
    "thumbsDown": "This was not useful",
    "intro": "Ask about anything you can already see in HUMIS. The assistant sees exactly what you see — nothing more.",
    "suggestions": [
      "How much annual leave do I have left?",
      "Explain my last payslip",
      "What do I need before my visa renewal?",
      "Who is off in my team next week?"
    ],
    "disclaimer": "The assistant reads your data with your own permissions and never changes anything on its own. Anything it wants to save is shown to you first.",
    "proposal": {
      "untitled": "A change the assistant would like to make",
      "confirm": "Confirm",
      "cancel": "Cancel",
      "notYetSaved": "Nothing is saved until you confirm.",
      "confirmed": "Saved.",
      "cancelled": "Cancelled. Nothing was saved.",
      "expired": "This expired before it was confirmed. Ask again to redo it.",
      "failed": "That could not be saved."
    }
  }
}
